export default __webpack_public_path__ + "static/media/jeep ride.d39153a5.jpg";